import { z } from 'zod';
import { localizedTextSchema } from './localized';

export const projectSchema = z.object({
  id: z.string().uuid().optional(),
  name: localizedTextSchema,
  depositArticleNumber: z.string().min(1, 'Artikelnummer (voorschot) is verplicht'),
  singleRoomArticleNumber: z.string().min(1, 'Artikelnummer (single kamer) is verplicht'),
  balanceArticleNumber: z.string().min(1, 'Artikelnummer (saldo) is verplicht'),
  activityArticleNumber: z.string().min(1, 'Artikelnummer (activiteiten) is verplicht'),
  activityDescription: localizedTextSchema,
  defaultCostUnit: z.string().nullable().optional(),
  depositAmount: z
    .string()
    .regex(/^\d+(\.\d{1,2})?$/, 'Ongeldige prijs')
    .nullable()
    .optional(),
  mollieProfile: z.enum(['nocc', 'cc']).default('nocc'),
  isActive: z.boolean().default(true),
});

export const createProjectSchema = projectSchema.omit({ id: true });
export const updateProjectSchema = projectSchema.partial().omit({ id: true });

export type ProjectFormData = z.infer<typeof createProjectSchema>;
export type ProjectSchema = z.infer<typeof projectSchema>;
